import * as Ariakit from '@ariakit/react';
import { forwardRef, useContext } from '@wordpress/element';
import { Icon } from '@wordpress/icons';
import { SVG, Circle } from '@wordpress/primitives';
import { Context } from './context';
import * as Styled from './styles';
import { useMenuItemHideOnClick } from './use-menu-item-hide-on-click';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const radioCheck = /*#__PURE__*/_jsx(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  children: /*#__PURE__*/_jsx(Circle, {
    cx: 12,
    cy: 12,
    r: 3
  })
});
export const RadioItem = forwardRef(function RadioItem({
  suffix,
  children,
  disabled = false,
  hideOnClick = false,
  ...props
}, ref) {
  const menuContext = useContext(Context);
  const store = menuContext?.store;
  const computedHideOnClick = useMenuItemHideOnClick(store, hideOnClick);
  if (!store) {
    throw new Error('Menu.RadioItem can only be rendered inside a Menu component');
  }
  return /*#__PURE__*/_jsxs(Styled.RadioItem, {
    ref: ref,
    ...props,
    accessibleWhenDisabled: true,
    disabled: disabled,
    store: store,
    hideOnClick: computedHideOnClick,
    children: [/*#__PURE__*/_jsx(Ariakit.MenuItemCheck, {
      store: store,
      render: /*#__PURE__*/_jsx(Styled.ItemPrefixWrapper, {})
      // Override some ariakit inline styles
      ,
      style: {
        width: 'auto',
        height: 'auto'
      },
      children: /*#__PURE__*/_jsx(Icon, {
        icon: radioCheck,
        size: 24
      })
    }), /*#__PURE__*/_jsxs(Styled.ItemContentWrapper, {
      children: [/*#__PURE__*/_jsx(Styled.ItemChildrenWrapper, {
        children: children
      }), suffix && /*#__PURE__*/_jsx(Styled.ItemSuffixWrapper, {
        children: suffix
      })]
    })]
  });
});